import React, { useState } from 'react';
import { useThroughputData } from '../hooks/useThroughputData';
import { FilterBar } from '../components/throughput/FilterBar';
import { KPIStrip } from '../components/throughput/KPIStrip';
import { ThroughputFunnel } from '../components/throughput/ThroughputFunnel';
import { LeadSourceBreakdown } from '../components/throughput/LeadSourceBreakdown';
import { LoanOfficerTable } from '../components/throughput/LoanOfficerTable';
import { Loader2, ChevronDown, ChevronUp } from 'lucide-react';
export function ThroughputDashboard() {
  const {
    isLoading,
    filters,
    setFilters,
    metrics,
    officers,
    filteredLeads,
    filteredOpportunities
  } = useThroughputData();
  const [showSourceBreakdown, setShowSourceBreakdown] = useState(false);
  const handleRefresh = () => {
    window.location.reload();
  };
  const handleRowClick = (officerId: string) => {
    setFilters({
      ...filters,
      scopeType: 'Loan Officer',
      selectedScopeId: officerId
    });
  };
  if (isLoading || !metrics) {
    return <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]" data-id="element-143">
        <div className="flex flex-col items-center" data-id="element-144">
          <div className="w-12 h-12 rounded-xl bg-[#7C3AED]/10 flex items-center justify-center mb-4" data-id="element-145">
            <Loader2 className="h-6 w-6 animate-spin text-[#7C3AED]" data-id="element-146" />
          </div>
          <p className="text-sm text-[#706E6B]" data-id="element-147">Loading dashboard...</p>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-[#F5F5F5]" data-id="element-148">
      <FilterBar filters={filters} setFilters={setFilters} officers={officers} onRefresh={handleRefresh} data-id="element-149" />

      <main className="max-w-[1600px] mx-auto px-6 py-8" data-id="element-150">
        {/* Page Header */}
        <div className="mb-8" data-id="element-151">
          <p className="text-xs font-semibold uppercase tracking-wider text-[#7C3AED] mb-1" data-id="element-152">
            Zoom Home Lending
          </p>
          <h1 className="text-2xl font-semibold text-[#181818] mb-1" data-id="element-153">
            Throughput Dashboard
          </h1>
          <p className="text-[#706E6B]" data-id="element-154">
            Cohort analysis of lead conversion performance
          </p>
        </div>

        {/* KPI Strip */}
        <KPIStrip metrics={metrics} data-id="element-155" />

        {/* Funnel */}
        <ThroughputFunnel metrics={metrics.funnelMetrics} data-id="element-156" />

        {/* Lead Source Toggle */}
        <button onClick={() => setShowSourceBreakdown(!showSourceBreakdown)} className="flex items-center gap-2 text-sm font-medium text-[#706E6B] hover:text-[#181818] mb-4 transition-colors" data-id="element-157">
          {showSourceBreakdown ? <ChevronUp className="h-4 w-4" data-id="element-158" /> : <ChevronDown className="h-4 w-4" data-id="element-159" />}
          {showSourceBreakdown ? 'Hide' : 'Show'} Lead Source Breakdown
        </button>

        {/* Lead Source Breakdown */}
        {showSourceBreakdown && <LeadSourceBreakdown leads={filteredLeads} opportunities={filteredOpportunities} data-id="element-160" />}

        {/* Officer Table */}
        <LoanOfficerTable metrics={metrics.officerMetrics} onRowClick={handleRowClick} data-id="element-161" />
      </main>
    </div>;
}